"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function filterOptions(opts, term) {
  var options = _lodash["default"].cloneDeep(opts);
  return _lodash["default"].filter(options, function (opt) {
    if (_lodash["default"].has(opt, 'children') && !_lodash["default"].isEmpty(opt.children)) {
      var filteredChildren = filterOptions(opt.children, term);
      _lodash["default"].set(opt, 'children', filteredChildren);
      if (filteredChildren.length <= 0) {
        return false;
      }
      return true;
    }
    return _lodash["default"].includes(_lodash["default"].toLower(opt.label), _lodash["default"].toLower(term));
  });
}
var _default = exports["default"] = filterOptions;